/* src/app/component/typewriter-text/typewriter-text.component.scss */
.typewriter--cursor {
  animation: blink 1s infinite;
  color: inherit;
  font-size: 1.4rem;
  line-height: 0;
  margin-left: 5px;
}
.typewriter--output p {
  display: inline;
}
@keyframes blink {
  0%, 50% {
    opacity: 1;
  }
  51%, 100% {
    opacity: 0;
  }
}
/*# sourceMappingURL=typewriter-text.component.css.map */
